import Model from "../Model";
import tw from "tailwind-styled-components";
import { SideCancelBtn, DeleteBtn } from "../Styles/InputStyles";

const DeleteVendor = ({
    setIsDeleteVendor,
    selectedData,
    deleteVendorLoading,
    deleteVendorMutate,
    handleClose
}) => {
    const handleDeleteSubmit = () => {
        deleteVendorMutate({
            vendorId: selectedData?.id,
        });
    };
    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsDeleteVendor}
            title="Confirm Deletion"
        >
            <WarningText>
                Are you sure you want to delete this vendor?
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4 mt-8">
                <SideCancelBtn
                    type="button"
                    onClick={handleClose}
                >
                    Cancel
                </SideCancelBtn>
                <DeleteBtn
                    onClick={handleDeleteSubmit}
                    disabled={deleteVendorLoading}
                    className="border border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white"
                >
                    {deleteVendorLoading ? "Deleting..." : "Delete"}
                </DeleteBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default DeleteVendor;